import { ICommonSearch } from '@models/common'
import { IHistoryOrder, IQueryHistoryOrders } from '@models/historyOrders'

export const historyOrderIntial: ICommonSearch<IQueryHistoryOrders, IHistoryOrder[]> = {
  search: {},
  data: [],
  currentPage: 0,
  totalPage: 0
}
